export const PLACEHOLDER_PRODUCT_IMAGE = '/placeholder-product.png';

const HOTLINK_BLOCKED_HOSTS = [
  'fbcdn.net',
  'facebook.com',
  'instagram.com',
  'cdninstagram.com',
];

export function isHotlinkBlockedUrl(url: string): boolean {
  try {
    const hostname = new URL(url).hostname;
    return HOTLINK_BLOCKED_HOSTS.some((host) => hostname.includes(host));
  } catch {
    return false;
  }
}

export function isSupabaseStorageUrl(url: string): boolean {
  if (url.includes('.supabase.co/storage')) {
    return true;
  }

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  return Boolean(supabaseUrl && url.includes(supabaseUrl));
}

export function isExternalImageUrl(url: string): boolean {
  if (!url || url.startsWith('/') || url.startsWith('data:')) {
    return false;
  }

  try {
    const parsed = new URL(url);
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      return false;
    }
    return !isSupabaseStorageUrl(url);
  } catch {
    return false;
  }
}

export function getProxiedImageUrl(url: string): string {
  return `/api/images/proxy?url=${encodeURIComponent(url)}`;
}

export function getDisplayImageSrc(url?: string | null): string {
  if (!url) return PLACEHOLDER_PRODUCT_IMAGE;
  // Load external URLs directly first; ProductImage falls back to the proxy on error.
  // Facebook/Instagram CDN URLs work in the browser (no-referrer) but block server-side proxy fetches.
  return url;
}

export function getProductImageUrl(images?: string[] | null): string {
  return getDisplayImageSrc(images?.[0]);
}
